var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormModal',{attrs:{"title":"Wanneer wil je de dakkapel plaatsen?","show-back-btn":""},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('ExecutionPeriodFormStep',{attrs:{"progress-value":_vm.progressValue}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }